import { DeskScreen } from "./DeskScreen";
import { SessionErrorScreen } from "./SessionErrorScreen";
import { SessionPendingScreen } from "./SessionPendingScreen";
import { SignInScreen } from "./SignInScreen";
import { useSession } from "../session/useSession";
import type { DeskDependencies } from "./DeskScreen";

/**
 * Chooses the surface for the current session state.
 *
 * Every branch renders exactly one `main` landmark with one level-1 heading, so the skip
 * link and the document outline stay correct no matter which state a seller lands in.
 */
export function SessionGate(desk: DeskDependencies) {
  const { state, retry } = useSession();

  switch (state.status) {
    case "checking":
      return <SessionPendingScreen />;
    case "signed-in":
      return <DeskScreen seller={state.seller} {...desk} />;
    case "signed-out":
      return <SignInScreen reason={state.reason} />;
    case "error":
      return <SessionErrorScreen reason={state.reason} onRetry={retry} />;
  }
}
